import axios from '@/api/axios';
import {toQueryString} from '@/api/queryString';
import type {
  AdminPaginatedEnvelope,
  AfriexBank,
  AfriexTransactionProcessor,
} from '@/types';

const commonEndpoint = '/v2/admin/banks';

export type BankListFilters = {
  page?: number;
  limit?: number;
  countryCodes: string[];
  processor?: AfriexTransactionProcessor;
  unmapped?: boolean;
  search?: string;
};

export const bankService = {
  /**
   * Banks in the given countries, optionally narrowed to those a processor
   * has a code for (`processor`) or to those no processor has a code for
   * (`unmapped`). The server rejects both together.
   */
  getBankList: async ({
    countryCodes,
    processor,
    unmapped,
    search,
    page = 0,
    limit = 10,
  }: BankListFilters) => {
    const urlParams = toQueryString({
      page,
      limit,
      countryCode: countryCodes.join(','),
      ...(processor ? {processor} : {}),
      ...(unmapped ? {unmapped: true} : {}),
      ...(search?.trim() ? {search: search.trim()} : {}),
    });
    const response = await axios.get<AdminPaginatedEnvelope<AfriexBank[]>>(
      `${commonEndpoint}?${urlParams}`,
    );
    return response.data;
  },
};
